module.exports = __webpack_public_path__ + "static/flow-refinance-hero-landscape-960w-635a909ff4d4ec58b1e6b2e02e3233b8.jpg";